<script setup>
const { model } = defineProps(['model'])
definePageMeta({
  layout: 'default',
})

const categoryId = computed(() => model?.contentLink?.id)

const {
  data,
  pageNumber,
  onPageChange,
  pending,
} = usePaginatedArticles(categoryId)

const { showFooterForm } = useLayoutFlags()
showFooterForm.value = true

const breadcrumbItems = computed(() => {
  return model?.breadcrumbLinks?.value?.map((link, index) => ({
    id: index,
    label: link.text || link.title,
    to: link.href,
  })) || []
})
</script>

<template>
  <div class="article-feed-page">
    <HeroBlock
      variation="no-curve"
      :color="model.pageHeroColorOnly?.heroColor?.value"
      :title="model.pageTitle?.value ? model.pageTitle?.value : model.name"
      :description="model.pageSummary.value"
    >
      <BreadCrumb
        :items="breadcrumbItems"
      />
    </HeroBlock>
    <div class="container-fluid mb-20">
      <TopicFilterBlock
        v-if="data?.articleFilters?.length"
        heading="Filter by Topic"
        :items="data?.articleFilters"
      />
      <UiLoaderOverlay :pending="pending">
        <ArticleListingBlock
          :show-article-summaries="model.showArticleSummaries?.value"
          :show-article-topics="model.showArticleTopics?.value"
          :cards="data?.articles"
        />
      </UiLoaderOverlay>
      <PaginationBlock
        v-if="data?.articlePageCount && data.articlePageCount > 1"
        :total="data.articleCount"
        :items-per-page="9"
        :on-page-change="onPageChange"
        :current-page="pageNumber"
        pagination-class="m-auto mt-0"
      />
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/pages/article-page.scss';
</style>
